import {
    Button,
    Card,
    Col,
    Row,
    Typography,
    InputNumber,
    Input,
    notification,
} from "antd";
import { Container } from "reactstrap";
import { CloseOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import React, { useState, useEffect, useContext, useRef } from "react";
import { PublicContext } from "../PublicContext";
import { useNavigate } from "react-router-dom";
import "./Cart.css";

export default function Payment() {
    const navigate = useNavigate();
    //const [cart, setCart] = useState([]);
    const { stores, setCartNum, setSpinning, cart, setCart, menuUrl, openNotification, promotions } = useContext(PublicContext);
    const [totals, setTotals] = useState({
        subtotal: 0,
        tax: 0,
        numItems: 0,
        delivery: 0,
        tip: 0,
        total: 0,
    });
    //const [isCartReady, setIsCartReady] = useState(false);
    const selectedStoreJSON = useRef(JSON.parse(sessionStorage.getItem("selectedStore")));
    const [selectedStore, setSelectedStore] = useState(stores.filter(s => s.storeCode === selectedStoreJSON.current.storeCode));
    const [submitDistabled, setSubmitDistabled] = useState(false);
    const paymentTimeoutRef = useRef(null);

    const { TextArea } = Input;
    const { Paragraph, Title } = Typography;

    const [api, contextHolder] = notification.useNotification();

    const [hpfScriptLoaded, setHpfScriptLoaded] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [outageDetected, setOutageDetected] = useState(false);

    const tipsString = sessionStorage.getItem("tips");
    const tips = parseFloat(tipsString);

    // Check if the parsed value is a valid number, otherwise default to 0
    const validTips = !isNaN(tips) ? tips : 0;

    let total = cart[0].totalPrice + validTips;

    useEffect(() => {
        //fetchCart();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        //// Dynamically create script element
        //const script = document.createElement('script');
        //script.src = 'https://chase.hostedpaymentservice.net/includes/hpfParent.min.js';
        //script.onload = handleScriptLoad;
        //script.onerror = handleScriptError;
        //script.id = 'chaseHpfScript';
        //// Append script to document body
        //document.body.appendChild(script);

        loadExternalScript('https://chase.hostedpaymentservice.net/includes/hpfParent.min.js')
            .then(() => {
                console.log('Script loaded successfully');
                handleScriptLoad();
                // Now that the script is loaded, you can attempt to access its functions
            })
            .catch(error => {
                console.error('Error loading script:', error);
                handleScriptError();
            });

        window.addEventListener('message', handleMessage, false);

        if (!cart) {
            navigate(`/menu?` + menuUrl);
        }

        if (!sessionStorage.getItem("paymentuid")) {
            navigate(`/checkout`);
        }

        return () => {
            window.removeEventListener('message', handleMessage, false);
            if (paymentTimeoutRef.current) clearTimeout(paymentTimeoutRef.current);
        };
    }, []);

    function loadExternalScript(url) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = url;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    function handleMessage(event) {
        if (event.data.subject === 'startPayment') {
            setSpinning(true);
            // Start timeout: if Chase HPF never responds, unblock the customer
            if (paymentTimeoutRef.current) clearTimeout(paymentTimeoutRef.current);
            paymentTimeoutRef.current = setTimeout(async () => {
                // HPF never responded — query the server, which checks Chase directly,
                // to find out whether the payment actually went through
                updateOrder("HPF timeout - no HPF response received, verifying payment status with server");
                await submitOrder(true); // server will call Chase's API to confirm
            }, 3 * 60 * 1000); // 3 minutes
            // Access the result returned by the startPayment function
            var result = event.data.content;
            //console.log('******************************Result from startPayment:', result);
            // Handle the result as needed
            if (window.gtag) {
                window.gtag('event', 'Payment', {
                    event_category: 'Button',
                    event_label: "Payment Start",
                });
            }
        }
        else if (event.data.subject === 'cancelPayment') {
            setSpinning(false);
            if (paymentTimeoutRef.current) { clearTimeout(paymentTimeoutRef.current); paymentTimeoutRef.current = null; }
            // Access the result returned by the cancelPayment function
            var result = event.data.content;

            if (window.gtag) {
                window.gtag('event', 'Payment', {
                    event_category: 'Button',
                    event_label: "Payment Cancel",
                });
            }

            //console.log('******************************Result from cancelPayment:', result);
            sessionStorage.removeItem("paymentuid");
            updateOrder("cancel payment");
            navigate(`/checkout`);
            // Handle the result as needed
        }
        else if (event.data.subject === 'completePayment') {
            setSpinning(false);
            if (paymentTimeoutRef.current) { clearTimeout(paymentTimeoutRef.current); paymentTimeoutRef.current = null; }
            // Access the result returned by the completePayment function
            var result = event.data.content;
            //console.log('******************************Result from completePayment:', result);
            //console.log(result.status);
            //console.log(result.status_message);
            // Handle the result as needed
            if (result.status_message === "Approved") {
                if (window.gtag) {
                    window.gtag('event', 'Payment', {
                        event_category: 'Button',
                        event_label: "Payment Complete",
                    });
                }
                submitOrder();
            }
        }
        else if (event.data.subject === 'hpfReady') {
            // Access the result returned by the hpfReady function
            var result = event.data.content;
            //console.log('******************************Result from hpfReady:', result);
            // Handle the result as needed
        }
        else if (event.data.subject === 'handleTransactionErrors') {
            setSpinning(false);
            if (paymentTimeoutRef.current) { clearTimeout(paymentTimeoutRef.current); paymentTimeoutRef.current = null; }
            // Access the result returned by the handleTransactionErrors function
            var result = event.data.content;
            //console.log('******************************Result from handleTransactionErrors:', result);
            //console.log(event.data);
            // Handle the result as needed
            var failedMessage = "";
            if (!result) {
                failedMessage = "No result. Invalid payment information";
                setErrorMessage("Invalid payment information");
            }
            else if (result.status_code === 2300) {
                if (result.gateway_code === "M1") {
                    failedMessage = "2300. Invalid address or postal code";
                    setErrorMessage("Invalid billing address or postal code");
                }
                else {
                    failedMessage = "2300. Invalid payment information";
                    setErrorMessage("Invalid payment information");
                }
            }
            else if (result.status_code === 2320) {
                failedMessage = "2320. Too many failed attempts";
                setErrorMessage("Too many failed attempts, please call the restaurant: " + selectedStore[0].storePhone);
            }
            else {
                if (Array.isArray(result)) {
                    setErrorMessage(result[0].status_message);
                }
                else {
                    setErrorMessage(result.status_message);
                }
                failedMessage = JSON.stringify(result);
            }

            if (window.gtag) {
                window.gtag('event', 'Payment', {
                    event_category: 'Button',
                    event_label: "Payment Fail: " + failedMessage,
                });
            }

            updateOrder(failedMessage);
        }
        else if (event.data.subject === 'displayErrors') {
            setSpinning(false);
            // Access the result returned by the displayErrors function
            var result = event.data.content;
            //console.log('******************************Result from displayErrors:', result);
            // Handle the result as needed
        }
        else {
            var result = event.data.content;
            //console.log('******************************Result from other:', event.data.subject + " " + result);
            setSpinning(false);
        }
    }

    const handleScriptLoad = () => {
        console.log("HPS script loaded");
        setHpfScriptLoaded(true);
    };

    const handleScriptError = () => {
        console.log("HPS script loading failed");
        setHpfScriptLoaded(false);
    };
    async function submitOrder(isTimeoutRecovery = false) {
        //let data = {
        //    OrderId: sessionStorage.getItem("orderId"),
        //    CartId: cart[0].cartId
        //}
        setSpinning(true);
        console.log("submitOrder")
        await fetch("api/Orders/CompletePayment?OrderId=" + sessionStorage.getItem("orderId"), {
            // await fetch("api/<OrderController>", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            //body: JSON.stringify(data),
        })
            .then(async (response) => {
                //setSpinning(false);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(response => {
                //console.log(response);
                //openNotification(response.status + " " + response.statusText);
                //const responseData = await response.json();
                //openNotification("Order Submitted");

                // Snapshot purchase data from cart NOW, before any state mutations
                // (setCart(null) below would make cart inaccessible via context on next render)
                const snapshotCart = cart && cart.length > 0 ? cart : [];
                const snapshotTotal = snapshotCart[0]?.totalPrice ?? 0;
                const snapshotTax = snapshotCart[0]?.orderTax ?? 0;
                const snapshotDelivery = snapshotCart[0]?.deliveryFee ?? 0;
                const snapshotOrderType = sessionStorage.getItem('deliveryOrPickUp') ?? '';
                const snapshotStoreLocation = selectedStore[0]?.storeName ?? '';

                const wholeOrderPromoNames = (() => {
                    try {
                        const parsed = JSON.parse(snapshotCart[0]?.wholeOrderPromotionName || '[]');
                        return Array.isArray(parsed) ? parsed.map(p => p.PromotionName).filter(Boolean) : [];
                    } catch (e) {
                        console.error('GA4 purchase: failed to parse wholeOrderPromotionName', e);
                        return [];
                    }
                })();
                const itemPromoNames = [...new Set(
                    snapshotCart
                        .filter(item => item.promotionId != null)
                        .map(item => (promotions || []).find(p => p.id === item.promotionId)?.promotionName)
                        .filter(Boolean)
                )];
                const allPromos = [...new Set([...wholeOrderPromoNames, ...itemPromoNames])].join(', ');

                const ecommerceData = {
                    transaction_id: response.orderId,
                    value: snapshotTotal + validTips,
                    tax: snapshotTax,
                    shipping: snapshotDelivery,
                    currency: 'CAD',
                    coupon: allPromos,
                    order_type: snapshotOrderType,
                    store_location: snapshotStoreLocation,
                    items: [],
                };

                try {
                    if (window.gtag) {
                        window.gtag('event', 'purchase', ecommerceData);
                    }
                } catch (e) {
                    console.error('GA4 purchase event failed:', e);
                }

                setCart(null);
                setCartNum(0);
                localStorage.removeItem("mandarinCart");
                localStorage.removeItem("cart");
                localStorage.setItem("orderId", response.orderId);
                sessionStorage.removeItem("paymentuid");
                sessionStorage.setItem("scheduleTime", "");
                sessionStorage.removeItem("selectedAddress");
                sessionStorage.removeItem("aptnum");
                sessionStorage.removeItem("securitycode");
                //openNotification("Navigating to Order Status Page");
                setSpinning(false);
                navigate(`/order?OrderId=${response.orderId}&Email=${response.email}`);
            })
            .catch((error) => {
                setSpinning(false);
                if (isTimeoutRecovery) {
                    // Server also could not confirm payment — likely a payment provider outage
                    setErrorMessage("We're currently experiencing an online payment outage. Your payment was not processed.");
                    updateOrder("HPF timeout + server Chase check also failed - payment outage");
                    sessionStorage.removeItem("paymentuid");
                    setOutageDetected(true);
                } else {
                    openNotification("error", error + " Please contact the restaurant: " + selectedStore[0].storePhone, 600);
                }
                //setSubmitDistabled(false);
            });
    }

    async function updateOrder(message) {
        //let data = {
        //    OrderId: sessionStorage.getItem("orderId"),
        //    CartId: cart[0].cartId
        //}
        await fetch("api/Orders/UpdatePayment?OrderId=" + sessionStorage.getItem("orderId") + "&message=" + message, {
            // await fetch("api/<OrderController>", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            }
        });
    }
    
    return (
        <Container tag="main">
            <div className="py-5 h-100">
                <Button
                    onClick={() => {
                        if (window.gtag) {
                            window.gtag('event', 'GoBackToCheckoutFromPayment', {
                                event_category: 'Button',
                                event_label: "GoBackToCheckoutFromPayment",
                            });
                        }
                        navigate(`/checkout`);
                    }}
                >
                    <ArrowLeftOutlined />
                    Back To Checkout
                </Button>
                {contextHolder}
                <Row className="justify-content-center align-items-center h-100">
                    <Col md={24} lg={24} xl={24}>
                        <Row>
                            <Col xs={24} md={12}>
                                <div className="p-4 CartMainDiv">
                                    <Title level={4} tag="h3" className="fw-bold mb-2 mt-2 pt-1">
                                        Secure Payment
                                    </Title>

                                    <div className="d-flex justify-content-between mt-4 mb-3" style={{ fontWeight: "500" }}>
                                        <Typography tag="h5" className="text-uppercase">
                                            Total price
                                        </Typography>
                                        <Typography tag="h5">$ {total.toFixed(2)}</Typography>
                                    </div>

                                    <div id="secureFrameWrapper">
                                        {!outageDetected && (hpfScriptLoaded && sessionStorage.getItem("paymentuid")) &&
                                            <iframe
                                                id="secureFrame"
                                                className="secureFrame"
                                                title="Chase Paymentech"
                                                style={{
                                                    backgroundColor: "transparent",
                                                    height: "900px",
                                                    width: "100%"
                                                }}
                                                //src={`https://chase-var.hostedpaymentservice.net/hpf/?uid=${sessionStorage.getItem("paymentuid")}` // dev}
                                                src={`https://chase.hostedpaymentservice.net/hpf/?uid=${sessionStorage.getItem("paymentuid")}`} // prod
                                            />
                                        }
                                    </div>

                                    {outageDetected && (
                                        <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #f5222d', borderRadius: '8px', backgroundColor: '#fff1f0' }}>
                                            <div style={{ fontSize: '16px', color: '#f5222d', fontWeight: '600', marginBottom: '8px' }}>
                                                Payment Service Unavailable
                                            </div>
                                            <div style={{ fontSize: '14px', color: '#595959', marginBottom: '16px' }}>
                                                We're experiencing an issue with our online payment service. Your payment may or may not have gone through — please call us and we'll sort it out right away.
                                            </div>
                                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#262626' }}>
                                                {selectedStore[0]?.storeName}: <a href={`tel:${selectedStore[0]?.storePhone}`}>{selectedStore[0]?.storePhone}</a>
                                            </div>
                                        </div>
                                    )}

                                    <div id="errorMsgPlaceHolder" style={{ position: 'relative', height: '50px', top: '-450px', zIndex: '10000' }}>
                                        {!outageDetected && errorMessage && (
                                            <div style={{
                                                fontSize: '16px',
                                                color: 'red',
                                                padding: '10px',
                                                borderRadius: '4px'
                                            }}>
                                                {errorMessage}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </Container>
    );
}
